// extracted by mini-css-extract-plugin
module.exports = {"textOverlay":"css_textOverlay__UEQIF"};